import { faCircle } from "@fortawesome/free-regular-svg-icons/faCircle";
export let iconCircle = faCircle;
export function overwriteCircle(icon) {
    iconCircle = icon;
}
export default iconCircle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2lyY2xlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NpcmNsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sOENBQThDLENBQUM7QUFFeEUsTUFBTSxDQUFDLElBQUksVUFBVSxHQUFHLFFBQVEsQ0FBQztBQUVqQyxNQUFNLFVBQVUsZUFBZSxDQUFDLElBQW9CO0lBQ2xELFVBQVUsR0FBRyxJQUFJLENBQUM7QUFDcEIsQ0FBQztBQUVELGVBQWUsVUFBVSxDQUFDIn0=